// extracted by mini-css-extract-plugin
export default {"table-container":"UserAssignment_table-container__8FTps","number":"UserAssignment_number__zVXjo"};